import { combineReducers } from 'redux-immutable'
import standardPriceListReducer from './standard-price-list-reducer'
import standardPriceCreateReducer from './standard-price-create-reducer'
import standardPriceEditReducer from './standard-price-edit-reducer'
import standardPriceGetReducer from './standard-price-get-reducer'
import standardPriceDeactivateReducer from './standard-price-deactivate-reducer'
import standardPriceExportReducer from './standard-price-export-reducer'

export default combineReducers({
  standardPriceList: standardPriceListReducer,
  standardPriceCreate: standardPriceCreateReducer,
  standardPriceEdit: standardPriceEditReducer,
  standardPriceGet: standardPriceGetReducer,
  standardPriceDeactivate: standardPriceDeactivateReducer,
  standardPriceExport: standardPriceExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/standard-price/index.js